export default function validation(response, messages) {
  if (!response?.data?.error?.validationErrors) return;

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('COMMANDE_ACHAT_LIEN_COMMANDE_VENTE_NOT_SANS_SUITE') === 0) {
      messages.push({ message: 'addEditCommande.errors.commandeVenteSansSuite' });
    }
    if (message.indexOf('COMMANDE_ACHAT_LIEN_COMMANDE_VENTE_CANT_BE_CHANGE_IF_BESOIN') === 0) {
      messages.push({ message: 'addEditCommande.errors.cantBeChangeIfBesoin' });
    }
    if (message.indexOf('DEVIS_COMMANDE_IS_LINKED_TO_NEEDS') === 0) {
      messages.push({ message: 'detailCommandeAchatFournisseur.errors.isLinkedToNeeds' });
    }
    if (message.indexOf('COMMANDE_ACHAT_WRONG_STATE_FOR_SANS_SUITE') === 0) {
      messages.push({ message: 'addEditCommande.errors.wrongStateForSansSuite' });
    }
  });
}
